import { X, LogIn, UserPlus } from 'lucide-react';

interface AuthRequiredModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
  onLogin: () => void;
  onSignup: () => void;
  placement?: 'center' | 'drawer';
}

export function AuthRequiredModal({
  isOpen,
  message,
  onClose,
  onLogin,
  onSignup,
  placement = 'center',
}: AuthRequiredModalProps) {
  if (!isOpen) return null;

  const wrapperClassName =
    placement === 'drawer'
      ? 'fixed inset-0 z-[80] flex items-center justify-center p-4 md:justify-end md:pr-[420px]'
      : 'fixed inset-0 z-[80] flex items-center justify-center p-4';

  return (
    <div className={wrapperClassName}>
      <button
        type="button"
        aria-label="Close"
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />

      <div className="relative w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="flex items-start justify-between border-b border-gray-200 px-5 py-4">
          <div>
            <h3 className="text-lg font-extrabold text-gray-900">Login required</h3>
            <p className="mt-1 text-sm text-gray-600">{message}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
            aria-label="Close modal"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-3 px-5 py-5">
          <button
            type="button"
            onClick={onLogin}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-3 text-sm font-extrabold text-white shadow-sm hover:bg-blue-700"
          >
            <LogIn className="h-4 w-4" />
            Sign in
          </button>
          <button
            type="button"
            onClick={onSignup}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm font-extrabold text-gray-900 shadow-sm hover:border-gray-400 hover:bg-gray-50 dark:border-white/20 dark:bg-white/10 dark:text-white dark:hover:bg-white/15"
          >
            <UserPlus className="h-4 w-4" />
            Sign up
          </button>
          {/* <button
            type="button"
            onClick={onClose}
            className="w-full rounded-xl bg-gray-100 px-4 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            Continue browsing
          </button> */}
        </div>
      </div>
    </div>
  );
}
